import { doubleOrNil } from '../../../utils/mpOchags';
// Хуки для расчетов Form4

import { useCallback } from 'react';
import { mobilePlotArea, mobileLayerStock, mobileLayerTotal, mobileStandTotals } from '../../../utils/mobileCalculations';

// Хук для расчета площади выдела
export const usePloshadVydel = (form1Data, dataType) => {
  const calculatePloshadVydel = useCallback(() => mobilePlotArea(form1Data, dataType), [form1Data, dataType]);

  return { calculatePloshadVydel };
};

// Хук для расчетов запасов
export const useZapasCalculations = (form1Data, independentForm2Data, calculatePloshadVydel) => {
  const calculateZapasSyroVydelForAllYarusy = useCallback(() => {
    if (!form1Data || !independentForm2Data?.yarusy_dependent) return {};
    
    const ploshadVydel = calculatePloshadVydel();
    const zapasResults = {};
    
    independentForm2Data.yarusy_dependent.forEach((yarus) => {
      const zapasSyroGa = doubleOrNil(yarus.zapassirga);
      
      if (zapasSyroGa > 0 && ploshadVydel > 0) {
        const result = zapasSyroGa * ploshadVydel;
        zapasResults[`Ярус ${yarus.yarus}`] = result.toFixed(2);
      } else {
        zapasResults[`Ярус ${yarus.yarus}`] = '0.00';
      }
    });
    
    return zapasResults;
  }, [form1Data, independentForm2Data, calculatePloshadVydel]);

  const getZapasSuhostoyForAllYarusy = useCallback(() => {
    if (!independentForm2Data?.yarusy_dependent) return {};
    
    const suhostoyResults = {};
    
    independentForm2Data.yarusy_dependent.forEach((yarus) => {
      const zapasSuhostoy = doubleOrNil(yarus.zapassuh);
      suhostoyResults[`Ярус ${yarus.yarus}`] = zapasSuhostoy.toFixed(2);
    });
    
    return suhostoyResults;
  }, [independentForm2Data]);

  const getZapasZahObshForAllYarusy = useCallback(() => {
    if (!independentForm2Data?.yarusy_dependent) return {};
    
    const zahObshResults = {};
    
    independentForm2Data.yarusy_dependent.forEach((yarus) => {
      const zapasZahObsh = doubleOrNil(yarus.zapaszahl);
      zahObshResults[`Ярус ${yarus.yarus}`] = zapasZahObsh.toFixed(2);
    });
    
    return zahObshResults;
  }, [independentForm2Data]);

  const calculateSumOfThreeZapasForAllYarusy = useCallback(() => {
    if (!independentForm2Data?.yarusy_dependent || !form1Data) return {};
    
    const ploshadVydel = calculatePloshadVydel();
    const sumResults = {};
    
    independentForm2Data.yarusy_dependent.forEach((yarus) => {
      const zapasSyroGa = doubleOrNil(yarus.zapassirga);
      let zapasSyroVydel = 0;
      
      if (zapasSyroGa > 0 && ploshadVydel > 0) {
        zapasSyroVydel = zapasSyroGa * ploshadVydel;
      }
      
      const zapasSuhostoy = doubleOrNil(yarus.zapassuh);
      const zapasZahObsh = doubleOrNil(yarus.zapaszahl);
      
      const sum = zapasSyroVydel + zapasSuhostoy + zapasZahObsh;
      sumResults[`Ярус ${yarus.yarus}`] = sum.toFixed(2);
    });
    
    return sumResults;
  }, [independentForm2Data, form1Data, calculatePloshadVydel]);

  const calculateZapasDensityForAllYarusy = useCallback(() => {
    if (!independentForm2Data?.yarusy_dependent || !form1Data) return {};
    
    const ploshadVydel = calculatePloshadVydel();
    const densityResults = {};
    
    if (ploshadVydel <= 0) {
      independentForm2Data.yarusy_dependent.forEach((yarus) => {
        densityResults[`Ярус ${yarus.yarus}`] = '0.00';
      });
      return densityResults;
    }
    
    independentForm2Data.yarusy_dependent.forEach((yarus) => {
      const zapasSyroGa = doubleOrNil(yarus.zapassirga);
      
      let zapasSyroVydel = 0;
      if (zapasSyroGa > 0 && ploshadVydel > 0) {
        zapasSyroVydel = zapasSyroGa * ploshadVydel;
      }
      
      const zapasSuhostoy = doubleOrNil(yarus.zapassuh);
      const zapasZahObsh = doubleOrNil(yarus.zapaszahl);
      
      const sum = zapasSyroVydel + zapasSuhostoy + zapasZahObsh;
      const density = sum / ploshadVydel;
      
      densityResults[`Ярус ${yarus.yarus}`] = density.toFixed(2);
    });
    
    return densityResults;
  }, [independentForm2Data, form1Data, calculatePloshadVydel]);

  const calculateTotalDensitySum = useCallback(() => {
    if (!independentForm2Data?.yarusy_dependent || !form1Data) {
      return 0;
    }
    
    const ploshadVydel = calculatePloshadVydel();
    
    if (ploshadVydel <= 0) {
      return 0;
    }
    
    let totalDensitySum = 0;
    
    independentForm2Data.yarusy_dependent.forEach((yarus) => {
      const zapasSyroGa = doubleOrNil(yarus.zapassirga);
      
      let zapasSyroVydel = 0;
      if (zapasSyroGa > 0 && ploshadVydel > 0) {
        zapasSyroVydel = zapasSyroGa * ploshadVydel;
      }
      
      const zapasSuhostoy = doubleOrNil(yarus.zapassuh);
      const zapasZahObsh = doubleOrNil(yarus.zapaszahl);
      
      const sum = zapasSyroVydel + zapasSuhostoy + zapasZahObsh;
      const density = sum / ploshadVydel;
      
      totalDensitySum += density;
    });
    
    return totalDensitySum;
  }, [independentForm2Data, form1Data, calculatePloshadVydel]);

  return {
    calculateZapasSyroVydelForAllYarusy,
    getZapasSuhostoyForAllYarusy,
    getZapasZahObshForAllYarusy,
    calculateSumOfThreeZapasForAllYarusy,
    calculateZapasDensityForAllYarusy,
    calculateTotalDensitySum
  };
};

// Хук для расчетов итогов
export const useTotalsCalculations = (
  formData,
  independentForm2Data,
  form1Data,
  calculatePloshadVydel,
  calculateTotalDensitySum
) => {
  const calculateYarusTotals = useCallback((yarusNumber, column) =>
    mobileLayerTotal(formData, yarusNumber, column), [formData]
  );

  const calculateTotalsByNasazhdeniya = useCallback(
    () => mobileStandTotals(formData, independentForm2Data, calculatePloshadVydel(), 4),
    [formData, independentForm2Data, calculatePloshadVydel]
  );

  const getDetailedSumFormula = useCallback(() => {
    if (!independentForm2Data?.yarusy_dependent || !form1Data) return {};
    
    const ploshadVydel = calculatePloshadVydel();
    const detailedResults = {};
    
    independentForm2Data.yarusy_dependent.forEach((yarus) => {
      const zapasSyroGa = doubleOrNil(yarus.zapassirga);
      
      let zapasSyroVydel = 0;
      if (zapasSyroGa > 0 && ploshadVydel > 0) {
        zapasSyroVydel = zapasSyroGa * ploshadVydel;
      }
      
      const zapasSuhostoy = doubleOrNil(yarus.zapassuh);
      const zapasZahObsh = doubleOrNil(yarus.zapaszahl);
      
      const sum = zapasSyroVydel + zapasSuhostoy + zapasZahObsh;
      
      const formula = `Ярус ${yarus.yarus}: ${zapasSyroVydel.toFixed(2)} + ${zapasSuhostoy.toFixed(2)} + ${zapasZahObsh.toFixed(2)} = ${sum.toFixed(2)} кбм`;
      const syroVydelFormula = `(где Запас сырораст. на выдел = ${zapasSyroGa.toFixed(2)} кбм/га × ${ploshadVydel.toFixed(2)} га = ${zapasSyroVydel.toFixed(2)} кбм)`;
      
      detailedResults[`Ярус ${yarus.yarus}`] = {
        formula: formula,
        syroVydelFormula: syroVydelFormula,
        result: sum.toFixed(2)
      };
    });
    
    return detailedResults;
  }, [independentForm2Data, form1Data, calculatePloshadVydel]);

  const getDetailedTotalsFormulas = useCallback(() => {
    if (!formData?.data || !independentForm2Data?.yarusy_dependent || !form1Data) return {};
    
    const ploshadVydel = calculatePloshadVydel();
    const totalDensitySum = independentForm2Data.yarusy_dependent.reduce((sum, tier) =>
      sum + mobileLayerStock(tier, ploshadVydel), 0);
    if (totalDensitySum <= 0) return {};

    const yarusTotals = {};
    const yarusNumbers = ['1', '2', '3'];
    
    yarusNumbers.forEach(yarusNum => {
      yarusTotals[yarusNum] = {
        bpodolap: calculateYarusTotals(yarusNum, 'bpodolap'),
        osldolap: calculateYarusTotals(yarusNum, 'osldolap'),
        sosldolap: calculateYarusTotals(yarusNum, 'sosldolap'),
        usdolap: calculateYarusTotals(yarusNum, 'usdolap'),
        svsuhdolap: calculateYarusTotals(yarusNum, 'svsuhdolap'),
        svvtrdolap: calculateYarusTotals(yarusNum, 'svvtrdolap'),
        svburdolap: calculateYarusTotals(yarusNum, 'svburdolap'),
        stsuhdolap: calculateYarusTotals(yarusNum, 'stsuhdolap'),
        stvtrdolap: calculateYarusTotals(yarusNum, 'stvtrdolap'),
        stburdolap: calculateYarusTotals(yarusNum, 'stburdolap'),
        sksporoda: calculateYarusTotals(yarusNum, 'sksporoda'),
        ooporoda: calculateYarusTotals(yarusNum, 'ooporoda'),
        toporoda: calculateYarusTotals(yarusNum, 'toporoda')
      };
    });
    
    const yarusDensities = {};
    independentForm2Data.yarusy_dependent.forEach(tier => {
      yarusDensities[tier.yarus] = mobileLayerStock(tier, ploshadVydel);
    });

    const columns = ['bpodolap', 'osldolap', 'sosldolap', 'usdolap', 'svsuhdolap', 'svvtrdolap', 'svburdolap', 'stsuhdolap', 'stvtrdolap', 'stburdolap', 'sksporoda', 'ooporoda', 'toporoda'];
    const detailedResults = {};
    
    columns.forEach(column => {
      let numerator = 0;
      const parts = [];
      
      Object.keys(yarusTotals).forEach(yarus => {
        const yarusTotal = yarusTotals[yarus][column] || 0;
        const density = yarusDensities[yarus] || 0;
        const product = yarusTotal * density;
        numerator += product;
        parts.push(`Ярус ${yarus}: ${yarusTotal.toFixed(2)} × ${density.toFixed(2)} = ${product.toFixed(2)}`);
      });
      
      const result = (numerator / totalDensitySum).toFixed(2);
      detailedResults[column] = {
        formula: `(${parts.join(' + ')}) / ${totalDensitySum.toFixed(2)} = ${result}`,
        result: result
      };
    });
    
    return detailedResults;
  }, [formData, independentForm2Data, form1Data, calculatePloshadVydel, calculateYarusTotals]);

  return {
    calculateYarusTotals,
    calculateTotalsByNasazhdeniya,
    getDetailedSumFormula,
    getDetailedTotalsFormulas
  };
};

